import { render, staticRenderFns } from "./TappeBox.vue?vue&type=template&id=3eeed354&scoped=true&"
import script from "./TappeBox.vue?vue&type=script&lang=js&"
export * from "./TappeBox.vue?vue&type=script&lang=js&"
import style0 from "./TappeBox.vue?vue&type=style&index=0&id=3eeed354&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eeed354",
  null
  
)

export default component.exports